export enum RoleScopeEnum {
  Location = 10,
  Organization = 20,
  Tenant = 30,
  Global = 100
}
